import React from 'react';
import { servicesData } from '../data/mock';
import { Shield, Scale, Building2 } from 'lucide-react';

const iconMap = {
  1: Shield,
  2: Scale,
  3: Building2
};

const Services = () => {
  return (
    <section id="services" className="relative py-20 md:py-28 lg:py-36 bg-white overflow-hidden">
      <div className="absolute inset-0 noise-bg" />
      
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-2xl mb-14 md:mb-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-[1.5px] bg-[#10b981]" />
            <span className="text-[11px] tracking-[0.2em] text-[#10b981] uppercase font-semibold">
              What We Do
            </span>
          </div>
          <h2 className="font-serif text-[1.75rem] sm:text-[2rem] md:text-[2.5rem] lg:text-[3rem] text-[#1a2e4a] leading-[1.12] tracking-[-0.01em]">
            Comprehensive risk architecture
          </h2>
          <p className="mt-4 md:mt-5 text-base md:text-lg text-slate-500 leading-relaxed">
            Three pillars of protection designed for those who demand precision in every detail.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {servicesData.map((service, index) => {
            const Icon = iconMap[service.id];
            return (
              <div
                key={service.id}
                className="group relative bg-[#f8f9fa] hover:bg-white border border-transparent hover:border-slate-200 p-7 md:p-8 lg:p-9 transition-all duration-500 hover:shadow-xl hover:shadow-slate-200/50 hover:-translate-y-1"
              >
                {/* Number watermark */}
                <span className="absolute top-4 right-5 text-6xl md:text-7xl font-serif text-slate-100 group-hover:text-[#10b981]/10 transition-colors duration-700 select-none">
                  {index + 1}
                </span>
                
                <div className="relative space-y-5">
                  {/* Icon container */}
                  <div className="w-11 h-11 flex items-center justify-center bg-[#1a2e4a] text-white group-hover:bg-[#10b981] transition-colors duration-500">
                    <Icon size={20} strokeWidth={1.5} />
                  </div>
                  
                  {/* Content */}
                  <div className="space-y-3">
                    <h3 className="font-serif text-xl md:text-[1.35rem] text-[#1a2e4a]">
                      {service.title}
                    </h3>
                    <p className="text-[11px] tracking-[0.12em] text-[#10b981] uppercase font-semibold">
                      {service.focus}
                    </p>
                    <p className="text-sm text-slate-500 leading-[1.75]">
                      {service.description}
                    </p>
                  </div>

                  {/* Bottom accent */}
                  <div className="w-0 group-hover:w-10 h-[1.5px] bg-[#10b981] transition-all duration-500" />
                </div>
              </div>
            );
          })}
        </div>

        {/* Full-width image strip */}
        <div className="mt-14 md:mt-20 relative h-44 md:h-56 lg:h-72 overflow-hidden">
          <img
            src="/images/services.jpg"
            alt="Geometric architectural ceiling"
            className="object-cover w-full h-full img-zoom"
          />
          <div className="absolute inset-0 bg-[#1a2e4a]/25" />
          {/* Overlay text */}
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="font-serif text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center px-6 drop-shadow-lg">
              Protecting what matters since 1996
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
